import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'
import { CrudStoreItemScout } from 'legacy/lut/classes/models/CrudStoreItemScout'
import { DataModel } from 'legacy/lut/classes/models/DataModel'
import {
  CreateAdditionalByModel,
  CreateExtByModel,
  CreateLegalExtByModel,
} from 'legacy/lut/classes/models/IFormPartners'
import businessProfileApi from 'legacy/lut/classes/services/api/BusinessProfileApi'
import { SearchApi } from 'legacy/lut/classes/services/api/SearchApi'
import { lookupGetState, lookupGetStateOld, read, save, setNextLookupState } from 'legacy/lut/store'
import { StoreForms } from 'legacy/lut/store/state'

import { IForm } from 'core-components/classes/models/IForm'
import { IDataProviderFilter, Logic, Operator } from 'core-components/types'
import { HttpCancel } from 'core/classes/http'
import { IDataTableSettings } from 'core/classes/models/IDataTable'
import { siteBuilderGetState } from 'core/sitebuilder/store'
import { CrudStore } from 'core/types/crudStore'
import { createTableFilter } from 'core/types/helpers/createTableFilter'

export enum Page {
  PD = 'partner_details',
  PMD = 'partner_master_data',
}

export const checkNewPartner = (partnerId: string) => {
  return !partnerId?.indexOf('new-') || !partnerId?.indexOf('portal-')
}
export class PartnerDataStoreService {
  public lookupGetStateOld = lookupGetStateOld
  public loading: Promise<void>

  public setNextLookupState = setNextLookupState
  public lookupGetState = lookupGetState

  private partnerPreprocess = (partner: IForm) => {
    // const APJCountry = ['China', 'Japan', 'Taiwan', 'Korea (Rep.)', 'Thailand', 'Vietnam']
    // if (APJCountry.includes(partner.Country)) {
    //   const CompanyLegalName = partner.CompanyLegalName
    //   partner.CompanyLegalName = partner.CompanyEnglishName
    //   partner.CompanyLegalNameNonLatin = CompanyLegalName
    // }
    if (partner.WorkflowStatus && partner.WorkflowStatus === 'Done') {
      const extFields = Object.keys(partner).filter(
        (key) => key.endsWith('Ext') && !~key.indexOf('Legal')
      )
      extFields.forEach((fieldName) => {
        if (fieldName === 'EntryIdExt') {
          return
        }
        const withoutExtName = fieldName.substr(0, fieldName.length - 3)
        partner[fieldName] = partner[withoutExtName]
      })
      partner.ModifiedValues = ''
    }

    if (partner.LegalWorkflowStatusExt && partner.LegalWorkflowStatusExt === 'Done') {
      const extFields = Object.keys(partner).filter(
        (key) => key.endsWith('Ext') && ~key.indexOf('Legal')
      )
      extFields.forEach((fieldName) => {
        if (fieldName === 'LegalEntryIdExt' || fieldName === 'LegalWorkflowStatusExt') {
          return
        }
        const withoutExtName = fieldName.substr(0, fieldName.length - 3)
        partner[fieldName] = partner[withoutExtName]
      })
      partner.LegalModifiedValuesExt = ''
    }
  }

  public constructor() {
    this.loading = new Promise<void>((resolve) => {
      this.loadingResolver = resolve
    })
  }

  public fetchConnector = async (data: IForm[]) => {
    if (data) {
      data.forEach((el) => this.partnerPreprocess(el))
      return data
    }
    return []
  }

  public loadingResolver: () => void = () => {}

  public createFilter = (
    props: any,
    settings?: IDataTableSettings | null | undefined
  ): IDataProviderFilter => {
    const fields = {
      HierarchyType: 'HierarchyType',
      ParentPartnerID: 'ParentPartnerID',
      PartnerID: 'PartnerID',
      LocationID: 'LocationID',
      TaxID: 'TaxID',
      CommunicationName: 'CommunicationName',
      CompanyLegalName: 'CompanyLegalName',
      MainPhone: 'MainPhone',
      AddressLine1: 'AddressLine1',
      AddressLine2: 'AddressLine2',
      AddressLine3: 'AddressLine3',
      State: 'State',
      Region: 'Region',
      ZIPCode: 'ZIPCode',
      City: 'City',
    }

    const innerFilters: any =
      this.getBasicFilter(props) === null ? [] : [this.getBasicFilter(props)]
    const { filterPartner } = this.lookupGetStateOld().masterDataWidget
    if ((filterPartner || '').length) {
      innerFilters.push(this.getFilterForSearch(filterPartner))
    }
    if (settings) {
      const settingsFilters = createTableFilter(settings, fields)
      if (settingsFilters && Object.keys(settingsFilters).length > 0) {
        innerFilters.push(settingsFilters)
      }
    }
    return {
      logic: Logic.AND,
      filters: innerFilters,
    }
  }

  public getBasicFilter = (props: any) => {
    const { fromPage, partnerId, onlyOpened, myLegal, allLegal, topPartnerId } = props
    const filter: IDataProviderFilter = {
      logic: Logic.AND,
      filters: [],
    }

    if (partnerId && topPartnerId !== '') {
      filter.filters = [
        {
          field: 'TopPartnerID',
          operator: Operator.EQUAL,
          value: topPartnerId || partnerId,
        },
      ]
    }

    if (onlyOpened) {
      return null
    } else if (myLegal) {
      filter.filters = [
        {
          field: 'LegalWorkflowStatusExt',
          operator: Operator.NOTEQUAL,
          value: 'Done',
        },
      ]
    } else if (allLegal) {
      filter.filters = [
        {
          field: 'LegalWorkflowStatusExt',
          operator: Operator.NOTEQUAL,
          value: 'Done',
        },
      ]
    } else {
      if (fromPage === Page.PD && partnerId) {
        filter.filters[filter.filters.length] = {
          field: 'PartnerID',
          operator: Operator.EQUAL,
          value: partnerId,
        }
      }
    }

    return filter.filters.length ? filter : null
  }

  public getFilterForSearch = (search: string) => {
    const fields = ['Email', 'PartnerID', 'TopPartnerID', 'CommunicationName']
    const searchFilter: IDataProviderFilter = {
      logic: Logic.OR,
      filters: [],
    }

    fields.forEach((field) => {
      searchFilter.filters[searchFilter.filters.length] = {
        field,
        operator: Operator.CONTAINS,
        value: search,
      }
    })

    return searchFilter
  }

  public setCurrentPartnerId = (partnerId: string | undefined) => {
    const lookupOldState = this.lookupGetStateOld()
    this.setNextLookupState({
      ...lookupOldState,
      partners: {
        ...lookupOldState.partners,
        currentPartnerId: partnerId,
      },
    })
  }

  public getCodes = async (partnerID: string[], pageSize?: number) => {
    if (partnerID.length) {
      const crudProg = CrudStore.get(CrudStoreItemScout.WW_PartnerFlags, 'getCodes-Program')
      crudProg.setFilter(
        SearchApi.getFilterForSearch(partnerID, undefined, ['Code', 'CodeName'], 'Program')
      )
      crudProg.setPaging({
        page: 0,
        pageSize: pageSize || 5,
      })
      crudProg.setSort({ field: 'Code', dir: 'asc' })
      const programCodes = await crudProg.fetch()

      const crudAcc = CrudStore.get(CrudStoreItemScout.WW_PartnerFlags, 'getCodes-Accreditation')
      crudAcc.setFilter(
        SearchApi.getFilterForSearch(partnerID, undefined, ['Code', 'CodeName'], 'Accreditation')
      )
      crudAcc.setPaging({
        page: 0,
        pageSize: pageSize || 5,
      })
      crudAcc.setSort({ field: 'Code', dir: 'asc' })
      const accreditationCodes = await crudAcc.fetch()

      return {
        ProgramCodes: programCodes,
        AccreditationCodes: accreditationCodes,
        partnerID: partnerID.join(),
        ProgramCodesPage: 1,
        AccreditationCodesPage: 1,
      }
    }
    return
  }

  public searchCodes = async (
    partnerID: string[],
    type: string,
    page: number,
    searchItems?: string,
    pageSize?: number,
    filter?: any
  ) => {
    if (partnerID.length) {
      const programCodes = await SearchApi.fetchProgramCodes(
        partnerID,
        page,
        pageSize || 5,
        searchItems,
        type,
        filter
      )
      return programCodes
    }
    return
  }

  public changePartnersExt = async (
    changedPartner: DataModel,
    legalStatus?: string,
    NeedUpdateInMetalocator: boolean = false,
    basicStatus?: string,
    appSource?: string,
    sourceRequestor?: string
  ) => {
    const isNewPartner = checkNewPartner(changedPartner.get('PartnerID'))

    const basicModified = isNewPartner
      ? changedPartner.modified
      : changedPartner.get('ModifiedValues') || []

    const legalModified = changedPartner.get('LegalModifiedValuesExt') || []

    let source = appSource
    const page = siteBuilderGetState().routeParams.page
    if (page === 'newpartners' || page === 'partner-dashboard' || page.includes('hpscoutso')) {
      source = 'Click&Go'
    } else if (!source && page.includes('request')) {
      source = 'Onboarding'
    }
    if (source && !changedPartner.get('Source')) {
      changedPartner.set('Source', source)
    }
    if (sourceRequestor) {
      changedPartner.set('SourceRequestor', sourceRequestor)
    }
    let changedPartnerExt
    const partnerExt =
      CreateExtByModel(changedPartner, checkNewPartner(changedPartner.get('PartnerID'))) || {}

    let changedPartnerAdditional
    if (basicModified.length) {
      let newStatus = changedPartner.get('WorkflowStatus') || 'New'
      const isRejected = newStatus === 'Rejected'
      const isDone = newStatus === 'Done'
      const isAwaitingContractsTeamApproval = newStatus === 'Awaiting Contracts Team Approval'
      if (changedPartner.modified.length > 0) {
        newStatus =
          basicStatus ||
          (isAwaitingContractsTeamApproval ? 'Awaiting Contracts Team Approval' : 'New')
      }

      const crud = CrudStore.get(
        partnerExt['PartnerID'] && checkNewPartner(partnerExt['PartnerID'])
          ? CrudStoreItem.NewPartners
          : CrudStoreItem.PartnerAllData,
        'PartnerDataStoreService-basicModified'
      )

      const allowChangePartnerExt =
        partnerExt['PartnerID'] &&
        (checkNewPartner(partnerExt['PartnerID']) || partnerExt['ModifiedValues'])

      if (allowChangePartnerExt) {
        partnerExt['WorkflowStatus'] = newStatus
        if (isRejected) {
          if (partnerExt.EntryId) {
            await crud.update({ formId: '406', code: 'PartnersExt' }, [
              { EntryId: partnerExt.EntryId },
            ])
          }
          await crud.delete(
            { formId: '406', code: 'PartnersExt' },
            { EntryId: partnerExt.EntryId },
            'EntryId'
          )
          partnerExt.EntryId = undefined
        } else if (isDone) {
          if (partnerExt.EntryId) {
            await crud.update({ formId: '406', code: 'PartnersExt' }, [
              { EntryId: partnerExt.EntryId, LastRequest: 'false' },
            ])
          }
          partnerExt.EntryId = undefined
        }
        const result = await crud[partnerExt.EntryId ? 'update' : 'create'](
          { formId: '406', code: 'PartnersExt' },
          [partnerExt]
        )
        changedPartnerExt = result[0]

        if (changedPartnerExt) {
          changedPartner.set('EntryIdExt', changedPartnerExt['EntryId'])
          changedPartner.set('WorkflowStatus', changedPartnerExt['WorkflowStatus'])
        }
      }
    }

    if (!checkNewPartner(changedPartner.get('PartnerID'))) {
      const partnerAdditional = CreateAdditionalByModel(changedPartner)
      partnerAdditional['NeedUpdateInMetalocator'] = NeedUpdateInMetalocator
      const crud = CrudStore.get(
        CrudStoreItem.PartnerAllData,
        'PartnerDataStoreService-additionalInfo'
      )
      const result = await crud[partnerAdditional.EntryId ? 'update' : 'create'](
        { formId: '458', code: 'PartnerAdditionalInfo' },
        [partnerAdditional]
      )
      changedPartnerAdditional = result[0]
      if (changedPartnerAdditional) {
        changedPartner.set('EntryIdAdd', changedPartnerAdditional.EntryId)
      }
    }

    let changedLegalExt
    if (!checkNewPartner(changedPartner.get('PartnerID')) && legalModified.length) {
      let newLegalStatus =
        changedPartner.get('LegalWorkflowStatus') || 'Awaiting Contracts Team Approval'
      const oldLegalStatus = changedPartner.rawDataFirstVersion['LegalWorkflowStatusExt']
      const crud = CrudStore.get(
        CrudStoreItem.PartnerAllData,
        'PartnerDataStoreService-legalModified'
      )

      if (!~changedPartner.modified.indexOf('LegalWorkflowStatusExt')) {
        newLegalStatus = 'Awaiting Contracts Team Approval'
      }

      if (legalStatus) {
        newLegalStatus = legalStatus
      }

      const legalExt = CreateLegalExtByModel(changedPartner)
      if ((legalExt || {})['PartnerID'] && (legalExt || {})['LegalModifiedValues']) {
        legalExt['LegalModifiedValues'] = legalExt['LegalModifiedValues'].map((value: string) =>
          value === 'LegalState' ? 'LegalStateProvince' : value
        )
        legalExt['LegalWorkflowStatus'] = newLegalStatus
        if (
          (newLegalStatus === 'Awaiting Contracts Team Approval' ||
            oldLegalStatus === 'Done' ||
            oldLegalStatus === 'Rejected') &&
          legalExt.EntryId &&
          oldLegalStatus !== newLegalStatus
        ) {
          legalExt.LegalProfilingComment = ''
          changedPartner.rawData.LegalProfilingComment = ''
          if (oldLegalStatus !== 'Done') {
            await crud.update({ formId: '502', code: 'Partner Legal Extend' }, [
              { EntryId: legalExt.EntryId },
            ])
            await crud.delete(
              { formId: '502', code: 'Partner Legal Extend' },
              { EntryId: legalExt.EntryId },
              'EntryId'
            )
          }
          legalExt.EntryId = undefined
        }
        const result = await crud[legalExt.EntryId ? 'update' : 'create'](
          { formId: '502', code: 'Partner Legal Extend' },
          [legalExt]
        )
        changedLegalExt = result[0]
        if (changedLegalExt) {
          changedPartner.set('LegalEntryIdExt', changedLegalExt['EntryId'])
          changedPartner.set('LegalWorkflowStatusExt', changedLegalExt['LegalWorkflowStatus'])
        }
      }
    }

    changedPartner.set(
      'Modified',
      (changedPartnerExt && changedPartnerExt.Modified) ||
        (changedPartnerAdditional && changedPartnerAdditional.Modified) ||
        (changedLegalExt && changedLegalExt.Modified)
    )
    if (changedPartnerAdditional) {
      changedPartner.set('ModifiedAdd', changedPartnerAdditional.Modified)
      changedPartner.set('ModifiedByAdd', changedPartnerAdditional.ModifiedBy)
    }
    this.loadingResolver()
    changedPartner.modified = []
    return changedPartner
  }

  public getStaticData = async (cancelObject: HttpCancel) => {
    const countriesCode = read(StoreForms.dropdowns, 'countriesCode')
    if (!countriesCode) {
      const getCountriesCode = await businessProfileApi.fetchCountriesCode(cancelObject)
      if (!cancelObject.canceled) {
        save(StoreForms.dropdowns, 'countriesCode', {
          items: getCountriesCode,
          total: getCountriesCode.length || 0,
        })
      }
    }
  }
}

const partnerDataStoreService = new PartnerDataStoreService()
export { partnerDataStoreService }
